import React from "react";

import "react-day-picker/lib/style.css";
import "src/styles/resultados.scss";

import DayPickerInput from "react-day-picker/DayPickerInput";
import MomentLocaleUtils, {
  formatDate,
  parseDate,
} from "react-day-picker/moment";
import { useState } from "react";
import { CaretRight, CaretLeft, CalendarBlank } from "phosphor-react";
import moment from "moment";

function ResultContainer({ children, setDate }) {
  const [currentDate, setCurrentDate] = useState(new Date());

  const handleChangeDate = (date) => {
    setDate(date);
    setCurrentDate(date);
  };

  function handleCurrentDayChange(selectedDay, modifiers, dayPickerInput) {
    handleChangeDate(selectedDay);
  }

  function subDate() {
    handleChangeDate(moment(currentDate).subtract(1, "day").toDate());
  }

  function addDate() {
    handleChangeDate(moment(currentDate).add(1, "day").toDate());
  }

  return (
    <div className="result-table">
      <header>
        <button>
          <CaretLeft
            size={20}
            color="var(--primary)"
            style={{ cursor: "pointer" }}
            onClick={subDate}
          />
        </button>
        <div style={{ position: "relative" }}>
          <DayPickerInput
            value={currentDate}
            onDayChange={handleCurrentDayChange}
            format="L"
            placeholder="DD/MM/YYYY"
            formatDate={formatDate}
            parseDate={parseDate}
            dayPickerProps={{
              selectedDays: currentDate,
              localeUtils: MomentLocaleUtils,
              locale: "pt-br",
            }}
          />
          <CalendarBlank
            size={20}
            color="var(--primary)"
            style={{ position: "absolute", right: 14, top: 14 }}
          />
        </div>
        <button>
          <CaretRight
            size={20}
            color="var(--primary)"
            style={{ cursor: "pointer" }}
            onClick={addDate}
          />
        </button>
      </header>
      {children}
    </div>
  );
}

export default ResultContainer;



// WEBPACK FOOTER //
// ./src/newDesign/components/result-container.jsx